import axios from 'axios'
import { getToken } from '~/redux/user/tokens'

const getCountryCode = (ip,countryCode) => {
  if (countryCode)
    return Promise.resolve(countryCode)

  let body = {};

  if(ip)
  {
    body.ip = ip;
  }

  return getToken().then(token => {
    return axios({
      url: 'https://api-internal-us-east-1.viewlift.com/ip/ipgeolocator', // todo: hardcoded for now
      baseURL: window.settings.apiBaseUrl,
      method: 'POST',
      params: { 'site': window.settings.internalName},
      data:body,
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'x-api-key': window.settings.baseAPIKey
      },
    }).then(res => {
      console.log(`${new Date()} Fetched country code\n`)
      return res.data.countryisocode
    })
  })
}

export default getCountryCode;
